import React, { ComponentProps, ReactNode } from 'react';

import PropTypes from 'prop-types';

import theme from '@adsk/alloy-react-theme';

import ActivityCard from '../ActivityCard';

type PhotoActivityCardProps = ComponentProps<typeof ActivityCard> & {
  label: ReactNode;
};

/**
 * PhotoActivityCard component. Describes a single photo add activity.
 */
const PhotoActivityCard = React.forwardRef<
  HTMLDivElement,
  PhotoActivityCardProps
>(({ label, children, ...props }, ref) => {
  return (
    <ActivityCard ref={ref} {...props}>
      {children}
      {label && (
        <span
          css={[
            theme.typography.caption,
            {
              color: theme.colors.charcoal700,
              marginTop: 6,
            },
          ]}
        >
          {label}
        </span>
      )}
    </ActivityCard>
  );
});

PhotoActivityCard.displayName = 'PhotoActivityCard';

PhotoActivityCard.propTypes = {
  ...ActivityCard.propTypes,
  /** The image name */
  label: PropTypes.node.isRequired,
  /** The image content */
  children: PropTypes.node,
};

export default PhotoActivityCard;
